import { store, getContext } from '@wordpress/interactivity';

store('gt-fse-faq', {
    state: {
        isOpen: false, // État initial
    },
    actions: {
        toggle: (event) => {
            const context = getContext();
            if (!context) {
                console.error("Le contexte n'a pas pu être récupéré dans l'action toggle");
                return;
            }
    
            // Utiliser l'élément qui a déclenché l'événement (le <summary>)
            const summary = event.currentTarget;
            const el = summary.closest('details[data-wp-interactive="gt-fse-faq"]');
    
            // Définir la hauteur actuelle avant de calculer la hauteur du contenu
            const summaryHeight = el.offsetHeight;
            const contentHeight = el.querySelector('.gt-fse-faq-content').scrollHeight;
    
            // Si l'élément est en cours de fermeture ou déjà fermé
            if (context.isOpen) {
                context.isOpen = false;
                
                // Fixe la hauteur actuelle
                el.style.height = `${el.offsetHeight}px`;
                el.animate([{ height: `${el.offsetHeight}px` }, { height: `${summaryHeight - contentHeight}px` }], {
                    duration: 400,
                    easing: 'ease-out',
                }).onfinish = () => {
                    el.open = false; // Met à jour l'état après animation
                    el.style.height = ''; // Réinitialise la hauteur
                };
            } else {
                context.isOpen = true;
                el.style.height = `${summaryHeight + contentHeight}px`; // Fixe la hauteur du résumé
    
                // Attendre que le navigateur ait rendu avant de mesurer le contenu
                window.requestAnimationFrame(() => {
                    el.animate([{ height: `${summaryHeight}px` }, { height: `${summaryHeight + contentHeight}px` }], {
                        duration: 400,
                        easing: 'ease-out',
                    }).onfinish = () => {
                        el.open = true; // Met à jour l'état après animation
                        el.style.height = ''; // Réinitialise la hauteur
                    };
                });
            }
        }
    },
    callbacks: {
        logToggleState: () => {
            const context = getContext();
        }
    }
});
